import React, { useState } from "react";
import {
  FaUserCircle,
  FaBars,
  FaHome,
  FaSuitcase,
  FaUser,
  FaLock,
  FaBuilding,
  FaList,
  FaFileAlt,
  FaSignOutAlt,
  FaComments
} from "react-icons/fa";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

export default function Dashboard() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("auth");
    navigate("/login");
    window.location.reload();
  };

  const menu = [
    { name: "Home", icon: <FaHome />, path: "/" },
    {
      name: "Professionals List",
      icon: <FaList />,
      path: "/professionals-list"
    },
    { name: "Salons", icon: <FaBuilding />, path: "/salons" },
    { name: "Private Suite", icon: <FaSuitcase />, path: "/private-suites" },
    { name: "Support", icon: <FaComments />, path: "/support-list" },
    { name: "Feedbacks", icon: <FaComments />, path: "/feedback-list" },
    { name: "Policies", icon: <FaFileAlt />, path: "/policy-editor" },
    { name: "Terms", icon: <FaFileAlt />, path: "/terms" },
    { name: "Profile Settings", icon: <FaUser />, path: "/profile-settings" },
    { name: "Change Password", icon: <FaLock />, path: "/change-password" },

    { name: "Logout", icon: <FaSignOutAlt />, action: handleLogout }
  ];

  const isActive = (itemPath) => {
    if (!itemPath) return false;

    const current = location.pathname;

    // Special handling for private suite detail
    if (itemPath === "/private-suites") {
      return (
        current === "/private-suites" ||
        current.startsWith("/private-suites/") ||
        current.startsWith("/private-suite/")
      );
    }

    // General matching
    return current === itemPath || current.startsWith(itemPath + "/");
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar overlay for mobile */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden transition-opacity ${
          mobileOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setMobileOpen(false)}
      />

      {/* Sidebar */}
      <aside
        className={`fixed z-30 top-0 left-0 h-full bg-white shadow-lg transition-all duration-300 flex flex-col
          ${collapsed ? "w-20" : "w-64"}
          ${
            mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
          }`}
      >
        <div className="flex items-center justify-between p-4 border-b">
          {!collapsed && <h2 className="text-xl font-semibold">Dashboard</h2>}
          <button
            className="p-1 rounded hover:bg-gray-200"
            onClick={() => setCollapsed(!collapsed)}
          >
            <FaBars />
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto">
          {menu.map((item) => (
            <Link
              key={item.name}
              to={item.path || "#"}
              onClick={item.action}
              className={`flex items-center gap-3 p-3 m-2 rounded-lg transition-colors ${
                isActive(item.path)
                  ? "bg-[#AF9C80] text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
            >
              {item.icon}
              {!collapsed && <span>{item.name}</span>}
            </Link>
          ))}
        </nav>
      </aside>

      {/* Content area */}
      <div className="flex-1 flex flex-col lg:pl-64">
        <header className="flex items-center justify-between bg-white shadow p-4">
          <div className="flex items-center gap-4">
            <button
              className="lg:hidden p-2 rounded hover:bg-gray-200"
              onClick={() => setMobileOpen(true)}
            >
              <FaBars className="text-xl" />
            </button>
            <FaUserCircle className="text-2xl text-gray-600" />
            <span className="font-medium">Admin</span>
          </div>
        </header>
        <main className="flex-1 bg-gray-100 p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
